import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getBaseURL } from '../../services/api';
import './FeedbackPage.css';

const FeedbackPage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [meta, setMeta] = useState(null);
  const [score, setScore] = useState(null);
  const [comment, setComment] = useState('');
  const [done, setDone] = useState(false);
  const [showGoogle, setShowGoogle] = useState(false);
  const [googleUrl, setGoogleUrl] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    fetch(`${getBaseURL()}/public/satisfaction/${encodeURIComponent(token)}`)
      .then(async (res) => {
        if (!res.ok) throw new Error('Link non valido');
        return res.json();
      })
      .then((data) => {
        setMeta(data);
        setGoogleUrl(data.googleReviewsUrl || '');
        if (data.submitted) {
          setDone(true);
          setScore(data.score);
          setShowGoogle(data.score >= 4 && !!data.googleReviewsUrl);
        }
        if (data.expired && !data.submitted) {
          setError('Questo link è scaduto.');
        }
      })
      .catch(() => setError('Link non valido o scaduto.'))
      .finally(() => setLoading(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (!score || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${getBaseURL()}/public/satisfaction/${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ score, comment }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.error || 'Invio non riuscito');
      }
      setDone(true);
      setShowGoogle(!!data.showGoogleReview);
      setGoogleUrl(data.googleReviewsUrl || googleUrl);
    } catch (err) {
      setError(err.message || 'Errore');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="feedback-page">
      <div className="feedback-card">
        <h1>Virtual Clinic</h1>
        <p className="feedback-lead">La tua opinione sulla visita</p>
        {loading && <p>Caricamento…</p>}
        {!loading && error && <p className="feedback-error">{error}</p>}
        {!loading && !error && done && (
          <div className="feedback-thanks">
            <p>Grazie per il feedback{score ? ` (${score}/5)` : ''}.</p>
            {showGoogle && googleUrl && (
              <p>
                Se vuoi, lascia anche una recensione su Google:{' '}
                <a href={googleUrl} target="_blank" rel="noreferrer">Scrivi una recensione</a>
              </p>
            )}
          </div>
        )}
        {!loading && !error && !done && meta && (
          <form onSubmit={submit} className="feedback-form">
            <fieldset>
              <legend>Valutazione (1–5)</legend>
              <div className="feedback-scores">
                {[1, 2, 3, 4, 5].map((n) => (
                  <button
                    key={n}
                    type="button"
                    className={score === n ? 'active' : ''}
                    onClick={() => setScore(n)}
                    aria-label={`Voto ${n}`}
                  >
                    {n}
                  </button>
                ))}
              </div>
            </fieldset>
            <label>
              Commento (opzionale)
              <textarea
                value={comment}
                onChange={(ev) => setComment(ev.target.value)}
                rows={4}
                maxLength={2000}
              />
            </label>
            <button type="submit" disabled={!score || submitting}>
              {submitting ? 'Invio…' : 'Invia feedback'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackPage;
